

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import favicon from './Components/Assets/favicon.svg'
import "@fontsource/roboto"; // Defaults to weight 400
import "@fontsource/roboto/700.css"; // For bold 700 weight
import '@fortawesome/fontawesome-free/css/all.min.css';



const link = document.querySelector('link[rel="icon"]') || document.createElement('link');
link.rel = 'icon';
link.type = 'image/x-icon';
link.href = favicon;
document.head.appendChild(link);
document.title = "Clear Healthcare Intake forms";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
);

reportWebVitals();
